import React, { Component } from "react";
import { Link } from "react-router-dom";
import Select from 'react-select';

import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlayCircle, faPauseCircle, faMicrophoneAlt } from '@fortawesome/free-solid-svg-icons';

import "../styles/Quiz.css";
import data from "../data/data";
import exercises from "../data/exerciseList";
import audio from "../data/time-out.m4a";

library.add(faPlayCircle, faPauseCircle, faMicrophoneAlt);

// Get the entire list of exercises
const fetchQuiz = (name) => {
  for (var i = 0; i < data.length; i++) {
    if (data[i].title === name) {
        return data[i];
    }
  }
}

function AnswerList(props) {
  const answers = props.answers;
  const listItems = answers.map((answer) =>
    <div key={answer.toString()} className="answer">
      <b>{answer.letter}</b>{answer.text}
    </div>
  );

  return (
    <div className="answerList">{listItems}</div>
  );
}

class Quiz extends Component {
  constructor(props) {
    super(props);
    this.fetchRoundQuestions = this.fetchRoundQuestions.bind(this);
    this.nextRound = this.nextRound.bind(this);
    this.nextQuestion = this.nextQuestion.bind(this);
    this.answerCustomQuestion = this.answerCustomQuestion.bind(this);
    this.changeView = this.changeView.bind(this);
    this.playAudio = this.playAudio.bind(this);
    this.audio = React.createRef();
    this.handleChange = this.handleChange.bind(this);
    this.endQuiz = this.endQuiz.bind(this);
    this.state = {
      quiz: fetchQuiz(props.location.state.chosenQuiz.selectedOption.label),
      exercises: exercises,
      currentRound: 0,
      currentQuestion: 0,
      viewState: "warm-up",
      customAnswer: "A",
      randomVideo: 1,
      selectedExercise: "",
      musicPlaying: 'play-circle'
    };
  }

  fetchRoundQuestions(round) {
    return this.state.quiz.rounds[round];
  }

  nextRound() {
    const { quiz, currentRound } = this.state;
    if (currentRound !== quiz.rounds.length - 1) {
      this.setState({ currentRound: currentRound + 1, currentQuestion: 0 });
    } 
    this.changeView();
  }

  nextQuestion() {
    const { quiz, currentRound, currentQuestion, viewState } = this.state;

    if (viewState !== "tiebreakerA") {
      if (currentQuestion === quiz.rounds[currentRound].questions.length - 1) {
        this.nextRound();
      } else {
        this.setState({ currentQuestion: currentQuestion + 1 });
        this.changeView();
      }
    } else {      
      this.changeView();
    }
  }

  playAudio() {
    const isPlaying = !this.audio.current.paused;
    if (isPlaying) {
      this.audio.current.pause();
      this.setState({ musicPlaying: 'play-circle'})
    } else {
      this.audio.current.play();
      this.setState({ musicPlaying: 'pause-circle'})
    }
  }
  
  handleChange(selectedExercise) {
    this.setState({ selectedExercise });
  };
  
  endQuiz() {
    this.setState({ viewState: "quizOver" });
  };

  answerCustomQuestion(round, answer) {
    if (round === 0) {
      switch(answer) {
        case "A":
          this.setState({ customAnswer: "A" });
          this.setState({ selectedExercise: { value: "Athletic Weightlifter", label: "Athletic Weightlifter" } });
          break;
        case "B":
          this.setState({ customAnswer: "B" });
          this.setState({ selectedExercise: { value: "Boxing Champ", label: "Boxing Champ" } });
          break;
        case "C":
          this.setState({ customAnswer: "C" });
          this.setState({ selectedExercise: { value: "Chariot Racerunner", label: "Chariot Racerunner" } });
          break;
        case "D":
          this.setState({ customAnswer: "D" });
          this.setState({ selectedExercise: { value: "Downhill Skier", label: "Downhill Skier" } });
          break;
        default:
          this.setState({ customAnswer: "A" });
          this.setState({ selectedExercise: { value: "Athletic Weightlifter", label: "Athletic Weightlifter" } });
          break;
      }
    }
    if (round === 1) {
      switch(answer) {
        case "A":
          this.setState({ customAnswer: "A" });
          this.setState({ selectedExercise: { value: "Applause Please", label: "Applause Please" } });
          break;
        case "B":
          this.setState({ customAnswer: "B" });
          this.setState({ selectedExercise: { value: "Bruce Lee", label: "Bruce Lee" } });
          break;
        case "C":
          this.setState({ customAnswer: "C" });
          this.setState({ selectedExercise: { value: "Combs and Brylcreem", label: "Combs and Brylcreem" } });
          break;
        case "D":
          this.setState({ customAnswer: "D" });
          this.setState({ selectedExercise: { value: "Dennis Hopper Easy Rider", label: "Dennis Hopper Easy Rider" } });
          break;
        default:
          this.setState({ customAnswer: "A" });
          this.setState({ selectedExercise: { value: "Applause Please", label: "Applause Please" } });
          break;
      }
    }
    if (round === 2) {
      switch(answer) {
        case "A":
          this.setState({ customAnswer: "A" });
          this.setState({ selectedExercise: { value: "Ascend Mount Everest", label: "Ascend Mount Everest" } });
          break;
        case "B":
          this.setState({ customAnswer: "B" });
          this.setState({ selectedExercise: { value: "Barn Dance USA", label: "Barn Dance USA" } });
          break;
        case "C":
          this.setState({ customAnswer: "C" });
          this.setState({ selectedExercise: { value: "Chinese Thai Chi Master", label: "Chinese Thai Chi Master" } });
          break;
        case "D":
          this.setState({ customAnswer: "D" });
          this.setState({ selectedExercise: { value: "Do the Can Can", label: "Do the Can Can" } });
          break;
        default:
          this.setState({ customAnswer: "A" });
          this.setState({ selectedExercise: { value: "Ascend Mount Everest", label: "Ascend Mount Everest" } });
          break;
      }
    }
    if (round === 3) {
      switch(answer) {
        case "A":
          this.setState({ customAnswer: "A" });
          this.setState({ selectedExercise: { value: "Agents of the Cold War", label: "Agents of the Cold War" } });
          break;
        case "B":
          this.setState({ customAnswer: "B" });
          this.setState({ selectedExercise: { value: "Buddha Under the Tree", label: "Buddha Under the Tree" } });
          break;
        case "C":
          this.setState({ customAnswer: "C" });
          this.setState({ selectedExercise: { value: "Clansmen Marching", label: "Clansmen Marching" } });
          break;
        case "D":
          this.setState({ customAnswer: "D" });
          this.setState({ selectedExercise: { value: "Drake Goes Bowling", label: "Drake Goes Bowling" } });
          break;
        default:
          this.setState({ customAnswer: "A" });
          this.setState({ selectedExercise: { value: "Agents of the Cold War", label: "Agents of the Cold War" } });
          break;
      }
    }
    
    this.changeView();
  };

  changeView() {
    const { currentRound, currentQuestion, viewState } = this.state;
    this.setState({ musicPlaying: 'play-circle'})
    switch (viewState) {
      case "warm-up":
        this.setState({ viewState: "round" });
        break;
      case "round":
        this.setState({ viewState: "question" });
        break;
      case "question":
        this.setState({ viewState: "answer" });
        break;
      case "answer":
        if (currentQuestion === 4) {
          if (currentRound === 3) {
            this.setState({ viewState: "tiebreaker" });
          } else {
            this.setState({ viewState: "round" });
            break;
          }
        } else {
          this.setState({ viewState: "question" });
        }
        break;
        case "tiebreaker":
          this.setState({ viewState: "tiebreakerQ" });
          this.setState({ selectedExercise: "" });
          break;
        case "tiebreakerQ":
          this.setState({ viewState: "tiebreakerA" });
          break;
        case "tiebreakerA":
          this.setState({ viewState: "exerciseSelect" });
          break;
        case "exerciseSelect":
          this.setState({ viewState: "finalExercise" });
          break;
      default:
        break;
    }
  }
  
  render() {
    const { currentRound, currentQuestion, viewState, exercises, selectedExercise, musicPlaying, customAnswer } = this.state;
    const round = this.fetchRoundQuestions(currentRound);
    const questions = round.questions;
    const { tiebreakerQuestion, tiebreakerAnswer, title } = this.state.quiz;

    let view, video, answerVideo, answerView;
        
    let exerciseList = exercises.map((exercise) => ({ value: exercise.video, label: exercise.title }));
  
    switch (selectedExercise.label) {
      case "Agents of the Cold War":
        video = 
          <video id="video" className="" controls>
            <source src={require("../data/exercise-videos/history-cold-war/history-cold-war.mp4")} type="video/mp4" />
            <track label="English" kind="subtitles" srcLang="en" src={require("../data/exercise-videos/history-cold-war/history-cold-war.vtt")} default />
              Sorry, your browser doesn't support embedded videos.
          </video>
          break;
      case "Applause Please":
        video = 
        <video id="video" className="" controls>
          <source src={require("../data/exercise-videos/entertain-applause/entertain-applause.mp4")} type="video/mp4" />
          <track label="English" kind="subtitles" srcLang="en" src={require("../data/exercise-videos/entertain-applause/entertain-applause.vtt")} default />
            Sorry, your browser doesn't support embedded videos.
        </video>
          break;
      case "Ascend Mount Everest":
        video = 
        <video id="video" className="" controls>
          <source src={require("../data/exercise-videos/world-everest/world-everest.mp4")} type="video/mp4" />
          <track label="English" kind="subtitles" srcLang="en" src={require("../data/exercise-videos/world-everest/world-everest.vtt")} default />
            Sorry, your browser doesn't support embedded videos.
        </video>
          break;
      case "Athletic Weightlifter":
        video = 
        <video id="video" className="" controls>
          <source src={require("../data/exercise-videos/sport-weightlifter/sport-weightlifter.mp4")} type="video/mp4" />
          <track label="English" kind="subtitles" srcLang="en" src={require("../data/exercise-videos/sport-weightlifter/sport-weightlifter.vtt")} default />
            Sorry, your browser doesn't support embedded videos.
        </video>
          break;
      case "Barn Dance USA":
        video = 
        <video id="video" className="" controls>
          <source src={require("../data/exercise-videos/world-barn-dance/world-barn-dance.mp4")} type="video/mp4" />
          <track label="English" kind="subtitles" srcLang="en" src={require("../data/exercise-videos/world-barn-dance/world-barn-dance.vtt")} default />
            Sorry, your browser doesn't support embedded videos.
        </video>
          break;
      case "Boxing Champ":
        video = 
        <video id="video" className="" controls>
          <source src={require("../data/exercise-videos/sport-boxing/sport-boxing.mp4")} type="video/mp4" />
          <track label="English" kind="subtitles" srcLang="en" src={require("../data/exercise-videos/sport-boxing/sport-boxing.vtt")} default />
            Sorry, your browser doesn't support embedded videos.
        </video>
          break;
      case "Bruce Lee":
        video = 
        <video id="video" className="" controls>
          <source src={require("../data/exercise-videos/entertain-kung-fu/entertain-kung-fu.mp4")} type="video/mp4" />
          <track label="English" kind="subtitles" srcLang="en" src={require("../data/exercise-videos/entertain-kung-fu/entertain-kung-fu.vtt")} default />
            Sorry, your browser doesn't support embedded videos.
        </video>
          break;
      case "Buddha Under the Tree":
        video = 
        <video id="video" className="" controls>
          <source src={require("../data/exercise-videos/history-buddha/history-buddha.mp4")} type="video/mp4" />
          <track label="English" kind="subtitles" srcLang="en" src={require("../data/exercise-videos/history-buddha/history-buddha.vtt")} default />
            Sorry, your browser doesn't support embedded videos.
        </video>
          break;
      case "Chariot Racerunner":
        video = 
        <video id="video" className="" controls>
          <source src={require("../data/exercise-videos/sport-chariots/sport-chariots.mp4")} type="video/mp4" />
          <track label="English" kind="subtitles" srcLang="en" src={require("../data/exercise-videos/sport-chariots/sport-chariots.vtt")} default />
            Sorry, your browser doesn't support embedded videos.
        </video>
          break;
      case "Chinese Thai Chi Master":
        video = 
        <video id="video" className="" controls>
          <source src={require("../data/exercise-videos/world-thai-chi/world-thai-chi.mp4")} type="video/mp4" />
          <track label="English" kind="subtitles" srcLang="en" src={require("../data/exercise-videos/world-thai-chi/world-thai-chi.vtt")} default />
            Sorry, your browser doesn't support embedded videos.
        </video>
          break;
      case "Clansmen Marching":
        video = 
        <video id="video" className="" controls>
          <source src={require("../data/exercise-videos/history-bagpipe/history-bagpipe.mp4")} type="video/mp4" />
          <track label="English" kind="subtitles" srcLang="en" src={require("../data/exercise-videos/history-bagpipe/history-bagpipe.vtt")} default />
            Sorry, your browser doesn't support embedded videos.
        </video>
          break;
      case "Combs and Brylcreem":
        video = 
        <video id="video" className="" controls>
          <source src={require("../data/exercise-videos/entertain-brylcreem/entertain-brylcreem.mp4")} type="video/mp4" />
          <track label="English" kind="subtitles" srcLang="en" src={require("../data/exercise-videos/entertain-brylcreem/entertain-brylcreem.vtt")} default />
            Sorry, your browser doesn't support embedded videos.
        </video>
          break;
      case "Dennis Hopper Easy Rider":
        video = 
        <video id="video" className="" controls>
          <source src={require("../data/exercise-videos/entertain-easy-rider/entertain-easy-rider.mp4")} type="video/mp4" />
          <track label="English" kind="subtitles" srcLang="en" src={require("../data/exercise-videos/entertain-easy-rider/entertain-easy-rider.vtt")} default />
            Sorry, your browser doesn't support embedded videos.
        </video>
          break;
      case "Do the Can Can":
        video = 
        <video id="video" className="" controls>
          <source src={require("../data/exercise-videos/world-can-can/world-can-can.mp4")} type="video/mp4" />
          <track label="English" kind="subtitles" srcLang="en" src={require("../data/exercise-videos/world-can-can/world-can-can.vtt")} default />
            Sorry, your browser doesn't support embedded videos.
        </video>
          break;
      case "Downhill Skier":
        video = 
        <video id="video" className="" controls>
          <source src={require("../data/exercise-videos/sport-ski/sport-ski.mp4")} type="video/mp4" />
          <track label="English" kind="subtitles" srcLang="en" src={require("../data/exercise-videos/sport-ski/sport-ski.vtt")} default />
            Sorry, your browser doesn't support embedded videos.
        </video>
          break;
      case "Drake Goes Bowling":
        video = 
        <video id="video" className="" controls>
          <source src={require("../data/exercise-videos/history-drake/history-drake.mp4")} type="video/mp4" />
          <track label="English" kind="subtitles" srcLang="en" src={require("../data/exercise-videos/history-drake/history-drake.vtt")} default />
            Sorry, your browser doesn't support embedded videos.
        </video>
          break;
      default:
        break;
    }

    switch (customAnswer) {
      case "A":
        answerView = <p className="correctAnswer">A:</p>
        break;
      case "B":
        answerView = <p className="correctAnswer">B:</p>
        break;
      case "C":
        answerView = <p className="correctAnswer">C:</p>
        break;
      case "D":
        answerView = <p className="correctAnswer">D:</p>
        break;
      default:
        answerView = <p className="correctAnswer">A:</p>
        break;
    }

    switch (viewState) {
      case "warm-up":
        view = 
          <div className="answerContent">
            <p className="roundNumber">Warm up</p>
            <h1>Warm up</h1>
            <div className="video-responsive">
              <video id="video" className="" controls>
                <source src={require("../data/exercise-videos/warm-up/warm-up.mp4")} type="video/mp4" />
                <track label="English" kind="subtitles" srcLang="en" src={require("../data/exercise-videos/warm-up/warm-up.vtt")} default />
                  Sorry, your browser doesn't support embedded videos.
              </video>
            </div>
            <button className="button next" onClick={this.changeView}>
              Start Quiz
            </button>
          </div>
          break;
      case "round":
        view = 
          <div className="roundContent">
            <p className="roundNumber">Round {currentRound + 1}</p>
            <h1 className={"roundName " + round.name}>{round.name}</h1>
            <button className="button" onClick={this.changeView}>
              Start round
            </button>
          </div>
          break;
      case "question":
        view = 
        ( title === "My Quiz" ? 
            (
              <div className="questionContent">
                <p className="roundNumber">Round {currentRound + 1}</p>
                <h1>Question {questions[currentQuestion].number}</h1>
                <p className="text">Answer the question from your quizmaster.</p>
                <div className="answerList">
                  <button className="answer" onClick={() => this.answerCustomQuestion(currentRound, "A")}>
                    <b>A: </b>
                  </button>
                  <button className="answer" onClick={() => this.answerCustomQuestion(currentRound, "B")}>
                    <b>B: </b>
                  </button>
                  <button className="answer" onClick={() => this.answerCustomQuestion(currentRound, "C")}>
                    <b>C: </b>
                  </button>
                  <button className="answer" onClick={() => this.answerCustomQuestion(currentRound, "D")}>
                    <b>D: </b>
                  </button>  
                </div>
                <button className="button countdown" onClick={this.playAudio}>
                  <FontAwesomeIcon icon={ musicPlaying } /> Countdown
                </button>
                <audio src={audio} ref={this.audio} />          
              </div>
            ) : 
            (
              <div className="questionContent">
                <p className="roundNumber">Round {currentRound + 1}</p>
                <h1>Question {questions[currentQuestion].number}</h1>
                <p className="text">{questions[currentQuestion].text}</p>
                <AnswerList answers={questions[currentQuestion].answers} />
                <button className="button next" onClick={this.changeView}>
                  Reveal Answer
                </button>
                <button className="button countdown" onClick={this.playAudio}>
                  <FontAwesomeIcon icon={ musicPlaying } /> Countdown
                </button>
                <audio src={audio} ref={this.audio} />
              </div>
            )
        )
          break;
      case "answer":
        view = ( title === "My Quiz" ? 
          (
            <div className="answerContent">
              <p className="roundNumber">Round {currentRound + 1}</p>
              <h1>Answer</h1>
              {answerView}
              <div className="video-responsive">          
                {video}
              </div>
              <button className="button next" onClick={this.nextQuestion}>
                { currentQuestion === (questions.length - 1) ? "Next Round" : "Next Question" }              
              </button>
            </div>
          ) : 
          (
            <div className="answerContent">
              <p className="roundNumber">Round {currentRound + 1}</p>
              <h1>Answer</h1>
              <p className="correctAnswer">{questions[currentQuestion].correctAnswer}</p>
              <div className="video-responsive">
                <video id="video" className="" controls>
                  <source src={questions[currentQuestion].video} type="video/mp4" />
                  <track label="English" kind="subtitles" srcLang="en" src={questions[currentQuestion].subtitles} default />
                    Sorry, your browser doesn't support embedded videos.
                </video>
              </div>
              <button className="button next" onClick={this.nextQuestion}>
                { currentQuestion === (questions.length - 1) ? "Next Round" : "Next Question" }              
              </button>
            </div>
          )
        )
        break;
      case "tiebreaker":
        view = 
          <div className="tiebreakerContent">
            <p className="roundNumber">Tie Breaker required?</p>
            <div className="buttons">
              <button className="button yes" onClick={this.changeView}>
                Yes
              </button>
              <button className="button no" onClick={this.endQuiz}>
                No
              </button>
            </div>
          </div>
          break;
      case "tiebreakerQ":
        view = ( title === "My Quiz" ? 
          (
            <div className="questionContent">
              <p className="roundNumber">Tiebreaker</p>
              <h1>Tiebreaker Question</h1>
              <p className="text">Answer the tiebreaker question from your quizmaster.</p>
              <button className="button next" onClick={this.changeView}>
                Reveal Answer
              </button>
              <button className="button countdown" onClick={this.playAudio}>
                <FontAwesomeIcon icon={ musicPlaying } />Countdown
              </button>
              <audio src={audio} ref={this.audio} />
            </div>
          ) : 
          (
            <div className="questionContent">
              <p className="roundNumber">Tiebreaker</p>
              <h1>Tiebreaker Question</h1>
              <p className="text">{tiebreakerQuestion}</p>
              <button className="button next" onClick={this.changeView}>
                Reveal Answer
              </button>
              <button className="button countdown" onClick={this.playAudio}>
                <FontAwesomeIcon icon={ musicPlaying } />Countdown
              </button>
              <audio src={audio} ref={this.audio} />
            </div>
          )
        )
        break;
      case "tiebreakerA":
        view = ( title === "My Quiz" ? 
          (
            <div className="answerContent">
              <p className="roundNumber">Tiebreaker</p>
              <h1>Tiebreaker Answer</h1>
              <p className="correctAnswer"></p>
              <button className="button next" onClick={this.changeView}>
                Select exercise
              </button>
            </div>
          ) : 
          (
            <div className="answerContent">
              <p className="roundNumber">Tiebreaker</p>
              <h1>Tiebreaker Answer</h1>
              <p className="correctAnswer">{tiebreakerAnswer}</p>
              <button className="button next" onClick={this.changeView}>
                Select exercise
              </button>
            </div>
          )
        )
        break;
      case "exerciseSelect":
        view = 
          <div className="answerContent">
            <p className="roundNumber">Tiebreaker</p>
            <h1>Select final exercise</h1>
            <p className="text">The winning team will now select the final exercise</p>
            <Select
              className="selector"
              value={selectedExercise}
              onChange={this.handleChange}
              options={exerciseList}
            />
            <button className="button select" onClick={this.changeView} disabled={selectedExercise === ""}>
              Select exercise
            </button>
          </div>
          break;
      case "finalExercise":
        view = 
          <div className="answerContent">
            <p className="roundNumber">Tiebreaker</p>
            <h1>Final exercise</h1>
            <div className="video-responsive">            
              {video}
            </div>
            <button className="button next" onClick={this.endQuiz}>
              End quiz
            </button>
          </div>
          break;
      case "quizOver":
        view = 
          <div className="tiebreakerContent">
            <h1 className="roundNumber">Quiz over!</h1>
            <Link className="button" to="/">Play Again</Link>
          </div>
          break;
      default:
        break;
    }
    
    return (
      <div className="quiz-screen">
        <div className="header">
            <img className="headerBanner" src={require("../assets/header-footer-colours.jpg")} alt="" />
            <div className="headerContent">
              <div className="logos">
                <img className="header" src={require("../assets/age-scotland-logo.png")} alt="Age Scotland logo" />
                <img className="header" src={require("../assets/power-quiz-logo.png")} alt="Power Quiz logo" />
              </div>
              <div className="nav">
                <Link className="" to="/about">Introduction</Link>
                <Link className="" to="/disclaimer">Disclaimer</Link>
              </div>
              <div className="logos"></div>
            </div>
        </div>
        {view}
        <div className="footerBanner">
            <img className="footer" src={require("../assets/header-footer-colours.jpg")} alt="" />
        </div>
      </div>
    );
  }
}

export default Quiz;
